var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mh-treeMenu-item" }, [
    _c("div", { staticClass: "mh-treeMenu-item__button" }, [
      _c("div", { class: [{ "button-content": true }, { leaf: _vm.isLeaf }] }, [
        _c(
          "div",
          { staticClass: "button__text", on: { click: _vm.toggleOpen } },
          [
            _vm._t(
              "default",
              [
                _vm.isLeaf == false
                  ? _c("ArrowIcon", {
                      attrs: { size: "small", direction: _vm.arrowDirection }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLeaf == false
                  ? _c("i", {
                      class: [
                        { fa: true },
                        { "fa-folder": !_vm.isOpen },
                        { "fa-folder-open": _vm.isOpen }
                      ],
                      staticStyle: { color: "#ffd26a" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLeaf == true
                  ? _c("i", {
                      class: [{ fa: true }, { "fa-file": true }],
                      staticStyle: { color: "#6c757d" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.item.name))])
              ],
              null,
              { item: _vm.item, isLeaf: _vm.isLeaf, isOpen: _vm.isOpen }
            )
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.isOpen && _vm.item.children
      ? _c(
          "div",
          { staticClass: "mh-treeMenu-item__children" },
          _vm._l(_vm.item.children, function(child, index) {
            return _c(
              "MenuItem",
              {
                key: child.name + index,
                attrs: { item: child, "on-select": _vm.onSelect },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.$scopedSlots, function(_, name) {
                      return {
                        key: name,
                        fn: function(slotData) {
                          return [_vm._t(name, null, null, slotData)]
                        }
                      }
                    })
                  ],
                  null,
                  true
                )
              },
              [
                _vm._l(_vm.$slots, function(_, name) {
                  return _vm._t(name, null, { slot: name })
                })
              ],
              2
            )
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }